import script from "./FeedPost.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeedPost.vue?vue&type=script&setup=true&lang=ts"

import "./FeedPost.vue?vue&type=style&index=0&id=1ba2560e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ba2560e"]])

export default __exports__